import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/components/ui/table";
import BorderedSelect from "src/components/form-new/bordered-select";
import { portalDs } from "src/components/portal-design-system/portal-ds-classes";
import { cn } from "src/lib/utils";
import type {
  CommissionSkuCategoryValue,
  SkuCategory,
} from "../types/commissions.types";
import { CommissionTableEmptyState } from "./commission-table-empty-state";

const CATEGORY_OPTIONS: Array<{ value: CommissionSkuCategoryValue | ""; label: string }> = [
  { value: "uncategorized", label: "Uncategorised" },
  { value: "programmatic", label: "Programmatic" },
  { value: "search_social", label: "Search & Social" },
  { value: "referral_client", label: "Referral client" },
  { value: "excluded_activation", label: "Excluded (Activation)" },
];

interface SkuCategoriesTableProps {
  skus: SkuCategory[];
  onCategoryChange: (skuId: string, category: CommissionSkuCategoryValue) => void;
  savingId?: string | null;
}

const SkuCategoriesTable: React.FC<SkuCategoriesTableProps> = ({
  skus,
  onCategoryChange,
  savingId = null,
}) => {
  return (
    <div className={portalDs.tableContainer}>
      <Table>
        <TableHeader>
          <TableRow className={portalDs.tableHead}>
            <TableHead className={portalDs.tableHeadCell}>SKU</TableHead>
            <TableHead className={portalDs.tableHeadCell}>Name</TableHead>
            <TableHead className={portalDs.tableHeadCell}>Category</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {skus.length === 0 ? (
            <CommissionTableEmptyState
              colSpan={3}
              title="No SKUs found"
              description="SKU categories will appear here once QuickBooks products are available."
            />
          ) : (
            skus.map((sku) => {
              const isSaving = savingId === sku.id;
              return (
                <TableRow key={sku.id} className={portalDs.tableBodyRow}>
                  <TableCell className={cn(portalDs.tableCell, "font-medium")}>
                    {sku.sku}
                  </TableCell>
                  <TableCell className={cn(portalDs.tableCell, portalDs.tableCellMuted)}>
                    {sku.skuName}
                  </TableCell>
                  <TableCell className={cn(portalDs.tableCell, "max-w-xs")}>
                    <div className="flex items-center gap-2">
                      <div className="min-w-0 flex-1">
                        <BorderedSelect
                          label=""
                          options={CATEGORY_OPTIONS}
                          value={sku.category ?? "uncategorized"}
                          disabled={isSaving}
                          onChange={(e) =>
                            onCategoryChange(
                              sku.id,
                              (e.target.value || "uncategorized") as CommissionSkuCategoryValue
                            )
                          }
                        />
                      </div>
                      {isSaving ? (
                        <span className={cn(portalDs.caption, "shrink-0")}>Saving…</span>
                      ) : null}
                    </div>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default SkuCategoriesTable;
